// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__jmyn8","error":"Textarea_error__37S0q","readonly":"Textarea_readonly__jt1yS","disabled":"Textarea_disabled__3CIme"};